import AlarmOptionPageContent from "../../components/organisms/AlarmOptionPageContent";
import { MoreTemplates } from "../../components/template/MoreTemplates";
import { useRecoilState } from "recoil";
import { alramState } from "../../states/user";

const AlarmOptionPage = () => {
  const [isAlramOn, setIsAlramOn] = useRecoilState(alramState);

  const onToggleHandler = () => {
    setIsAlramOn(!isAlramOn);
  };

  return (
    <MoreTemplates
      pageTitle="알림 설정"
      pageHeaderTitle="설정"
      background="white"
    >
      <AlarmOptionPageContent
        onToggleHandler={onToggleHandler}
        isAlramOn={isAlramOn}
      />
    </MoreTemplates>
  );
};

export default AlarmOptionPage;
